import Network from '@/services/network'
import { ref } from 'vue'

export default function handlePaymentRequisition() {
    const network = new Network
    const loading = ref(false)

    const fetchPaymentRequisitionList = (query) => {
        return network.api('get', '/payment-requisition/list' + query)
    }

    const fetchPaymentRequisitionReviewDetails = (id, query) => {
        return network.api('get', `/payment-requisition/${id}/review` + query)
    }

    const fetchPaymentRequisitionVoucherPdf = (id, query) => {
        return network.api('get', `/payment-requisition/${id}/voucher-pdf` + query)
    }

    const fetchPaymentRequisitionTopSheet = (data) => {
        return network.api('post', '/payment-requisition/top-sheet', data)
    }

    const startLedgerApproval = (id, data) => {
        return network.api('put', `/ledger/${id}/start-ledger-approval`, data)
    }

    const updateLedgerCheque = (id, data) => {
        return network.api('put', `/ledger/${id}/update-cheque`, data)
    }

    const updateLedgerStatus = (id, data) => {
        return network.api('put', `/ledger/${id}/status/update`, data)
    }

    const paymentRequisitionMakePayment = (id, data) => {
        return network.api('post', `/payment-requisition/${id}/make-payment`, data)
    }

    const paymentRequisitionBulkMakePayment = (data) => {
        return network.api('post', '/payment-requisition/beftn/bulk-make-payment', data)
    }

    const fetchBeftnBatchList = (query) => {
        return network.api('get', '/payment-requisition/beftn/batches' + query)
    }

    return {
        loading,
        fetchPaymentRequisitionList,
        fetchPaymentRequisitionReviewDetails,
        fetchPaymentRequisitionVoucherPdf,
        fetchPaymentRequisitionTopSheet,
        startLedgerApproval,
        updateLedgerCheque,
        updateLedgerStatus,
        paymentRequisitionMakePayment,
        paymentRequisitionBulkMakePayment,
        fetchBeftnBatchList,
    }
}
